import React from "react";
import {
  ResponsiveContainer,
  RadarChart,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  Legend,
  Tooltip,
} from "recharts";
import { PHASES, TIER_MODELS, SCALE_MAX, phaseAverage } from "@/data/coachingData";
import { useI18n } from "@/i18n";

const CHART_COLORS = ["#6366F1", "#F59E0B", "#10B981", "#EC4899", "#8B5CF6", "#06B6D4"];

export function CompetencyRadarChart({ modelType, scores }) {
  const { t } = useI18n();
  const tiers = TIER_MODELS[modelType] || TIER_MODELS["4-tier"];
  const data = PHASES.map((phase) => {
    const row = { phase: t(`phase.${phase.key}.title`).split(" · ").pop() };
    tiers.forEach((tier) => {
      row[t(`tierShort.${tier.key}`)] = +phaseAverage(scores, tier.key, phase.key).toFixed(1);
    });
    return row;
  });

  return (
    <div className="h-[360px] w-full" data-testid="competency-radar-chart">
      <ResponsiveContainer width="100%" height="100%">
        <RadarChart data={data} outerRadius="70%">
          <PolarGrid stroke="#CBD5E1" />
          <PolarAngleAxis dataKey="phase" tick={{ fill: "#9CA3AF", fontSize: 11 }} />
          <PolarRadiusAxis domain={[0, SCALE_MAX]} tick={{ fill: "#4B5563", fontSize: 10 }} stroke="#CBD5E1" />
          {tiers.map((tier, i) => (
            <Radar
              key={tier.key}
              name={t(`tierShort.${tier.key}`)}
              dataKey={t(`tierShort.${tier.key}`)}
              stroke={CHART_COLORS[i % CHART_COLORS.length]}
              fill={CHART_COLORS[i % CHART_COLORS.length]}
              fillOpacity={0.12}
              strokeWidth={2}
            />
          ))}
          <Legend wrapperStyle={{ fontSize: 12, color: "#9CA3AF" }} />
          <Tooltip
            contentStyle={{
              background: "#ffffff",
              border: "1px solid #CBD5E1",
              borderRadius: 12,
              color: "#0F172A",
              fontSize: 12,
            }}
          />
        </RadarChart>
      </ResponsiveContainer>
    </div>
  );
}
